import * as bootstrap from 'bootstrap';

export function llamarToast(mensaje, tipo) {
    // Crear el toast dinámicamente
    const toastContainer = document.getElementById('toast-container') || createToastContainer();
    const toastId = 'toast-' + Date.now();
    
    let bgClass = '';
    let textClass = 'text-white';
    
    switch (tipo) {
        case 'success':
            bgClass = 'bg-success';
            break;
        case 'danger':
        case 'error':
            bgClass = 'bg-danger';
            break;
        case 'info':
            bgClass = 'bg-info';
            break;
        case 'warning':
            bgClass = 'bg-warning';
            textClass = 'text-dark';
            break;
        default:
            bgClass = 'bg-secondary';
            break;
    }

    const toastHTML = `
        <div id="${toastId}" class="toast ${bgClass} ${textClass}" role="alert" aria-live="assertive" aria-atomic="true">
            <div class="toast-header ${bgClass} ${textClass}">
                <strong class="me-auto">Notificación</strong>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="toast" aria-label="Close"></button>
            </div>
            <div class="toast-body">
                ${mensaje}
            </div>
        </div>
    `;

    toastContainer.insertAdjacentHTML('beforeend', toastHTML);
    
    const toastElement = document.getElementById(toastId);
    const toast = new bootstrap.Toast(toastElement, {
        autohide: true,
        delay: 5000
    });
    
    toast.show();
    
    // Limpiar el toast después de que se oculte
    toastElement.addEventListener('hidden.bs.toast', () => {
        toastElement.remove();
    });
}

function createToastContainer() {
    const container = document.createElement('div');
    container.id = 'toast-container';
    container.className = 'toast-container position-fixed top-0 end-0 p-3';
    container.style.zIndex = '9999';
    document.body.appendChild(container);
    return container;
}
